import React, { useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';

const AUTO_DISMISS_MS = 6000;

const BellSmall = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    style={{ verticalAlign: 'middle' }}>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const Toast = ({ toast, onDismiss }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => onDismiss(toast.id), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast.id, onDismiss]);

  const handleClick = () => {
    onDismiss(toast.id);
    navigate('/notifications');
  };

  return (
    <div
      role="alert"
      onClick={handleClick}
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        padding: '12px 16px',
        background: '#fff',
        border: '1px solid #dee2e6',
        borderLeft: '4px solid #0d6efd',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        cursor: 'pointer',
        maxWidth: '360px',
        width: '100%',
        animation: 'slideInRight 0.25s ease',
      }}
    >
      <span style={{ color: '#0d6efd', flexShrink: 0, paddingTop: '2px' }}>
        <BellSmall />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: '0.8rem', color: '#6c757d', marginBottom: '2px' }}>
          New notification
        </div>
        <div style={{ fontSize: '0.9rem', color: '#212529', wordBreak: 'break-word' }}>
          {toast.text}
        </div>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={(e) => { e.stopPropagation(); onDismiss(toast.id); }}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#adb5bd',
          fontSize: '1rem',
          lineHeight: 1,
          padding: '0 0 0 4px',
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
};

const NotificationToastContainer = () => {
  const { toasts, dismissToast } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <>
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(110%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
      `}</style>
      <div
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          pointerEvents: 'none',
        }}
      >
        {toasts.map(toast => (
          <div key={toast.id} style={{ pointerEvents: 'auto' }}>
            <Toast toast={toast} onDismiss={dismissToast} />
          </div>
        ))}
      </div>
    </>
  );
};

export default NotificationToastContainer;
